import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CustomSlider from 'components/ui-kit/CustomSlider'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { GamesProviderHeadingIcon } from 'components/ui-kit/Icons/svg/index'
import {
  setViewAllGames
} from 'redux-thunk/redux/slices/games.slice'
import { ROUTE_PATHS } from 'constants/index'
import { getCasinoProvidersList } from 'redux-thunk/thunk/game.thunk'

const ST8_CDN = 'https://luckmedia.link'

const getProviderLogoUrl = (item) => {
  if (item?.logo) return item.logo
  if (item?.slug) return `${ST8_CDN}/providers/${item.slug}/logo_3_2_cl_light.svg`
  return null
}

const ProviderCard = ({ item, onClick }) => {
  const logoUrl = getProviderLogoUrl(item)
  return (
    <div className='theme-card provider-card-st8' onClick={onClick}>
      <div className='provider-logo'>
        {logoUrl
          ? (
            <img
              src={logoUrl}
              alt={item?.name}
              onError={(e) => {
                e.target.style.display = 'none'
                e.target.nextSibling && (e.target.nextSibling.style.display = 'flex')
              }}
            />
            )
          : null}
        <span className='provider-name-fallback' style={{ display: logoUrl ? 'none' : 'flex' }}>
          {item?.name}
        </span>
      </div>
      <div className='provider-badge-wrap'>
        {item?.gameCount > 0 ? `${item.gameCount} Games` : item?.name}
      </div>
    </div>
  )
}

const ProvidersListing = (props) => {
  const { homeCasinoSettings } = props
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const { providers } = useSelector((state) => state.games)
  const LIMIT = 30

  useEffect(() => {
    dispatch(getCasinoProvidersList({ offset: 0, limit: LIMIT }))
  }, [])

  return (
    <section className='provider-section'>
      <div className='inner-heading  d-block  d-lg-flex align-items-center justify-content-between'>
        <div className='d-flex align-items-center mb-3 mb-lg-0'>
          <GamesProviderHeadingIcon className='heading-icon' />
          <h4 className='text-uppercase'>{t('providers')}</h4>
          <a
            href=''
            className='heading-link'
            onClick={(e) => {
              e.preventDefault()
              history.push(ROUTE_PATHS.PROVIDERS)
              dispatch(setViewAllGames(null))
            }}
          >{t('viewAll')}
          </a>
        </div>
      </div>
      <div className='slide-wrap providers-slide p-0 m-0'>
        <CustomSlider {...homeCasinoSettings}>
          {providers?.rows?.map(item =>
            <div
              key={item?.providerId}
              className='col px-06'
              onClick={(e) => {
                e?.preventDefault()
                history.push(`${ROUTE_PATHS.PROVIDERS}/${item?.name}`, { providerId: item?.providerId })
              }}
            >
              <ProviderCard item={item} />
            </div>)}
        </CustomSlider>
      </div>
    </section>
  )
}

export default React.memo(ProvidersListing)
